export const DEMO_DISTRICTS_ROUTES = {
  name: 'demo-districts',
  route(): string[] {
    return ['/' + this.name];
  },
  DEFAULT: '',
  CREATE: {
    name: 'create',
    route(): string[] {
      return [...DEMO_DISTRICTS_ROUTES.route(), this.name];
    }
  },
  VIEW: {
    name: ':demoDistrictId',
    route(demoDistrictId: string): string[] {
      return [...DEMO_DISTRICTS_ROUTES.route(), demoDistrictId];
    }
  },
  defaultRedirectRoute(): string {
    const route = DEMO_DISTRICTS_ROUTES.route();
    if (route[0].startsWith('/')) {
      route[0] = route[0].slice(0);
    }

    return route.join('/');
  }
};
